import {updateLiveModeAction} from "../redux_actions/admin.state.action";
import {liveModeLoadingMessages} from "./const";
import cookie from "react-cookies";
import {message} from "antd";
import {
    updateAccessRevoked,
    updateAccessToLiveMode,
    updateBrightness,
    updateContrast
} from "../redux_actions/livemode.action";
import {store} from "../helper/store";
import {notNull} from "./utils";
import {get_response} from "../helper/request";

const sendRequestToScano = (url) => {
    store.dispatch(updateLiveModeAction(true, liveModeLoadingMessages.MODIFYING_SETTINGS));
    get_response(url)
        .then(response => {
            if (response.status !== 200) {
                console.log(response);
                store.dispatch(updateAccessRevoked(true));
                store.dispatch(updateAccessToLiveMode(false));
            }
            store.dispatch(updateLiveModeAction(false, liveModeLoadingMessages.MODIFYING_SETTINGS));
        })
        .catch(err => {
            console.log(err);
            message.error("Not able to set Brightness!!", 2.5);
            store.dispatch(updateLiveModeAction(false, liveModeLoadingMessages.MODIFYING_SETTINGS));
        })
}

export const setLivemodeBrightness = (value) => {
    if (!store.getState().livemodeReducer.live_mode_action) {
        let partsOfUrl = "api~settings~set_livemode_brightness/";
        let url = `/server/scano_text/` + store.getState().livemodeReducer.deviceId + `/` + partsOfUrl + "?value=" + value + "&access_code=" + cookie.load('livemode_access_code');
        sendRequestToScano(url);
    } else {
        message.error("Action ongoing...");
    }
}

export const setLivemodeContrast = (value) => {
    if (!store.getState().livemodeReducer.live_mode_action) {
        let partsOfUrl = "api~settings~set_livemode_contrast/";
        let url = `/server/scano_text/` + store.getState().livemodeReducer.deviceId + `/` + partsOfUrl + "?value=" + value + "&access_code=" + cookie.load('livemode_access_code');
        sendRequestToScano(url);
    } else {
        message.error("Action ongoing...");
    }
}

export const updateLivemodeSettingsInReducer = (settingId) => {
    //SettingId -> 0 -> All
    //SettingId -> 1 -> Brightness
    //SettingId -> 2 -> Contrast
    const deviceId = store.getState().livemodeReducer.deviceId
    const livemodePolling = store.getState().deviceStatusReducer[deviceId]?.scanner_health?.livemode_config
    if ((settingId === 0 || settingId === 1) && notNull(livemodePolling?.livemodeBrightness)) {
        store.dispatch(updateBrightness(livemodePolling?.livemodeBrightness))
    }
    if ((settingId === 0 || settingId === 2) && notNull(livemodePolling?.livemodeContrast)) {
        store.dispatch(updateContrast(livemodePolling?.livemodeContrast))
    }
}